var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"ex",staticStyle:{"padding-top":"10px"}},[_c('pageBanner',{attrs:{"list":_vm.homeBanners}})],1),_c('liveShare',{ref:"liveShare"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }